import { FaqBand } from "@/components/marketplace"
import type { FaqBandSection } from "@/features/feed/contract"
import { resolveFeedLink } from "@/features/feed/resolve-link"
import { SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"

export const FaqBandFeedSection = ({ section, context }: FeedSectionProps<FaqBandSection>) => {
  const { title, accent, sub, items, cta } = section.data
  return (
    <SectionFrame section={section} context={context} gut>
      <FaqBand title={title} accent={accent} sub={sub} items={items} cta={cta?.label} ctaHref={cta ? resolveFeedLink(cta.link, context.countryCode, context.page) : undefined} />
    </SectionFrame>
  )
}
